import { React } from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "../../../assets/images/check.png";
import { useTranslation } from "react-i18next";

const ApplicationSubmitted = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box
        sx={{
          px: 5,
          py: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          background: '#FFFFFF'
        }}
      >
        <Box
          sx={{
            width: "100px",
            height: "100px",
            bgcolor: '#F0F9FF',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
            boxShadow: '0 0 0 10px #F8FAFC'
          }}
        >
          <img
            src={CheckIcon}
            alt="success"
            style={{ width: 48, height: 48, objectFit: 'contain' }}
          />
        </Box>

        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "1.75rem",
            color: "#1E293B",
            fontFamily: "Outfit, sans-serif",
            mb: 2
          }}
        >
          {t("AgentRegistration.Application_Submitted")}
        </Typography>

        <Typography
          sx={{
            fontSize: "1rem",
            color: "#64748B",
            maxWidth: '400px',
            lineHeight: 1.6,
            mb: 6
          }}
        >
          {t("AgentRegistration.Application_sent_to_the_administrator")}
        </Typography>

        <Box
          sx={{
            p: 3,
            bgcolor: '#F8FAFC',
            borderRadius: '16px',
            width: '100%',
            border: '1px solid #F1F5F9'
          }}
        >
          <Typography sx={{ fontSize: '0.875rem', color: '#64748B' }}>
            We'll review your application and get back to you within 2-3 business days.
          </Typography>
        </Box>
      </Box>
    </>
  );
};
export default ApplicationSubmitted;
